export enum BetActionType {
    bet = 1,
    cashout,
    cancel
}
